module.exports = __webpack_public_path__ + "img/logo-blanc.18a6243e.svg";